import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameManager} from '../UIGameManager'
import {PlayerValidator, MechanicValidatorLongestRoad} from '@colonist/game-mechanic-validators'
import {MechanicLongestRoadState, PlayerColor} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameAddAchievementEvent} from '@colonist/ui-game'

export class UIGameLongestRoadController {
    protected readonly uiGameManager: UIGameManager

    private readonly longestRoadValidator: MechanicValidatorLongestRoad
    private lastPlayerToHoldLongestRoad: PlayerColor

    constructor(uiGameManager: UIGameManager, longestRoadState: MechanicLongestRoadState) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.longestRoadValidator = new MechanicValidatorLongestRoad(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, longestRoadState)
        this.lastPlayerToHoldLongestRoad = this.longestRoadValidator.getPlayerWithLongestRoadCard()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updateLongestRoadStatus(data); break
            default: break
        }
    }

    private updateLongestRoadStatus(animate: boolean) {
        this.resetLastLongestRoadIfNoPlayerHasLongestRoad()
        for(const player of this.uiGameManager.gameState.players) {
            const longestRoadPlayerState = this.longestRoadValidator.getLongestRoadPlayerState(player.color)
            if(!longestRoadPlayerState.hasLongestRoad) continue
            if(player.color == this.lastPlayerToHoldLongestRoad) continue

            this.playerAchievedLongestRoad(player, animate)
        }
    }

    private resetLastLongestRoadIfNoPlayerHasLongestRoad() {
        for(const player of this.uiGameManager.gameState.players) {
            const longestRoadPlayerState = this.longestRoadValidator.getLongestRoadPlayerState(player.color)
            if(longestRoadPlayerState.hasLongestRoad) return
        }
        this.lastPlayerToHoldLongestRoad = PlayerColor.None
    }

    private playerAchievedLongestRoad(playerState: PlayerValidator, animate: boolean) {
        const longestRoadPlayerState = this.longestRoadValidator.getLongestRoadPlayerState(playerState.color)
        const longestRoadScore = longestRoadPlayerState.longestRoad

        const achievement: UIGameAddAchievementEvent = {
            achievementOwnerNew: playerState.color,
            achievementOwnerPrevious: this.lastPlayerToHoldLongestRoad,
            achievementScore: longestRoadScore,
            achievementType: 'LongestRoad',
        }

        this.lastPlayerToHoldLongestRoad = playerState.color

        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement)
    }
}
